import { useEffect, useState } from 'react'
import { buildUserImageUrl, getUserImageVersion, USER_IMAGE_UPDATED_EVENT } from '../api/userImage'
import './user-avatar.css'

export function UserAvatar({ username, className = '' }: { username: string; className?: string }) {
  const [failed, setFailed] = useState(false)
  const [imageVersion, setImageVersion] = useState(() => getUserImageVersion(username))
  const useLegacyImage = import.meta.env.VITE_API_MODE === 'legacy'
  const imageUrl = buildUserImageUrl(username, import.meta.env.VITE_API_BASE_URL)

  useEffect(() => {
    const refresh = (event: Event) => {
      if ((event as CustomEvent<string>).detail.toLocaleLowerCase() !== username.toLocaleLowerCase()) return
      setFailed(false)
      setImageVersion(getUserImageVersion(username) ?? Date.now().toString())
    }
    window.addEventListener(USER_IMAGE_UPDATED_EVENT, refresh)
    return () => window.removeEventListener(USER_IMAGE_UPDATED_EVENT, refresh)
  }, [username])

  return (
    <span className={`user-avatar ${className}`.trim()} aria-hidden="true">
      {!failed && useLegacyImage ? (
        <img
          src={imageVersion ? `${imageUrl}&v=${imageVersion}` : imageUrl}
          alt=""
          loading="lazy"
          referrerPolicy="no-referrer"
          onError={() => setFailed(true)}
        />
      ) : (
        <span>{username.trim().charAt(0).toUpperCase() || '?'}</span>
      )}
    </span>
  )
}
